import { get } from 'lodash-es'

import { useFlags } from '@/feature/feature-flags'

export const useFlag = <T = unknown>(flag: string, fallback?: T): T => {
  const flags = useFlags()

  return get(flags, flag, fallback)
}
